<template>
    <div class="no-content">
        <div class="no-content__content">
           <slot></slot>
        </div>
        <div>
           <img src="../assets/Illustaions.png">
        </div>
    </div>
</template>
<script>
import Button from "@/components/button.vue"

export default {
    name: 'NoContent',
    components: {
       Button 
    },
}
</script>
<style lang="scss" scoped>
  .no-content {
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 90px 94px;
    display: flex;
    justify-content: space-between;
    margin: 0 30px;

    &__content {
        display: flex;
        flex-direction: column;
    }

    h1 {
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 29px;
        color: #261940;
        margin-bottom: 13px;
    }

    p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #261940;
        opacity: 0.7;
        padding: 5px 0;
    }

    h4 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #261940;
        padding-top: 20px;
        padding-bottom: 5px;
    }

    .tab__content__top__item {
        margin-top: 20px;
        margin-left: 0;
    }
  }
</style>